import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CMSProvider } from "./context/CMSContext";
import ScrollToHash from "./components/ScrollToHash";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import SuccessStoriesPage from "./pages/SuccessStoriesPage";
import CaseStudyPage from "./pages/CaseStudyPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";
import OurWorkPage from "./pages/OurWorkPage";
import LegalPage from "./pages/LegalPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CMSProvider>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/success-stories" element={<SuccessStoriesPage />} />
            <Route path="/success-stories/:slug" element={<CaseStudyPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/terms" element={<LegalPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </CMSProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
